import api from './api';

const supportService = {
  getSettings: async () => {
    const response = await api.get('/admin/support/settings');
    return response.data.data;
  },

  updateSettings: async (data) => {
    const response = await api.put('/admin/support/settings', data);
    return response.data.data;
  },

  getFaqs: async () => {
    const response = await api.get('/admin/support/faqs');
    return response.data.data;
  },

  createFaq: async (data) => {
    const response = await api.post('/admin/support/faqs', data);
    return response.data.data;
  },

  updateFaq: async (id, data) => {
    const response = await api.put(`/admin/support/faqs/${id}`, data);
    return response.data.data;
  },

  deleteFaq: async (id) => {
    const response = await api.delete(`/admin/support/faqs/${id}`);
    return response.data;
  },
};

export default supportService;

